import { render, staticRenderFns } from "./FishingDetail.vue?vue&type=template&id=e5b7b282&scoped=true&"
import script from "./FishingDetail.vue?vue&type=script&lang=js&"
export * from "./FishingDetail.vue?vue&type=script&lang=js&"
import style0 from "./FishingDetail.vue?vue&type=style&index=0&id=e5b7b282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b7b282",
  null
  
)

export default component.exports